import angular from 'angular';
import _ from 'lodash';

class modalAddAttributeCtrl {
  /* @ngInject */
  constructor(INVOICE_PARAM, ORDER_PARAM) {
    this.INVOICE_PARAM = INVOICE_PARAM;
    this.ORDER_PARAM = ORDER_PARAM;
  }

  $onInit() {
    this._attributesSelected = [];
    this.attributes = angular.copy(this.resolve.attributes);
    this.typeSection = angular.copy(this.resolve.typeSection);
    this.nbAttribute = angular.copy(this.resolve.nbAttribute);
    this.filters = angular.copy(this.resolve.filters);
  }

  ////////////////
  /**
   * Sélection d'un attribut
   */
  selectAttribute(path) {
    var length = this.attributes.length;
    for (var i = 0; i < length; i++) {
      var attTmp = this.attributes[i];
      if (attTmp.path === path) {
        // Si l'attribut est déjà sélectionné
        if (attTmp.selected) {
          // On le supprime du tableau des attributs à ajouter à la section
          this._attributesSelected.splice(_.findIndex(this._attributesSelected, { path: path }), 1);
          attTmp.selected = false;
          attTmp.section = null;
        } else {
          // Sinon on l'ajoute en indiquant l'ordre de tri
          attTmp.section = this.typeSection;
          // Selon le critère de filtre on coche la lad et la saisie ou non
          attTmp.lad = false;
          attTmp.saisie = false;
          attTmp.presenceLad = this.INVOICE_PARAM.presenceOptions[0];
          attTmp.presenceSaisie = this.INVOICE_PARAM.presenceOptions[0];
          attTmp.presence = attTmp.visible ? this.ORDER_PARAM.presenceOptions[0] : this.ORDER_PARAM.presenceOptions[1];
          attTmp.rawOrder = attTmp.order;
          this._attributesSelected.push(attTmp);
          attTmp.selected = true;
        }
      }
    }
  }

  validate() {
    if (this._attributesSelected) {
      this.modalInstance.close(this._attributesSelected);
    } else {
      this.modalInstance.dismiss();
    }
  }

  cancel() {
    this.modalInstance.dismiss();
  }
}

angular.module('app.principal').component('modalAddAttribute', {
  templateUrl: require('./modal-add-attribute.html'),
  controller: modalAddAttributeCtrl,
  bindings: {
    modalInstance: '<',
    resolve: '<'
  }
});
